export default "__VITE_ASSET__D9r__Nwk__"